import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Predictions from "@/pages/Predictions";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import Consult from "@/pages/Consult";
import Account from "@/pages/Account";
import OrderTracking from "@/pages/OrderTracking";
import { Login, Register } from "@/pages/Auth";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AppProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route path="/store" element={<Store />} />
              <Route path="/product/:sku" element={<ProductDetail />} />
              <Route path="/consult" element={<Consult />} />
              <Route path="/account" element={<Account />} />
              <Route path="/order/:sessionId" element={<OrderTracking />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
